import { ResizableModule } from 'angular-resizable-element';

import { OverlayContainer, OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { ExistingFullscreenOverlayContainer } from '@lib/ui/overlay';
import { SnIconModule } from 'libs/ui/icon/src/lib/icon.module';

import {
  SnDrawerComponent,
  SnDrawerHeaderComponent,
  SnDrawerFooterComponent,
  SnDrawerHeaderActionsComponent,
} from './components';
import { SnDrawerContainer } from './containers';
import {
  SnDrawerTitleDirective,
  SnDrawerCloseDirective,
  SnDrawerContentDirective,
  SnDrawerNavButtonDirective,
  SnDrawerAppContentDirective,
} from './directives';
import { SnDrawerService } from './services';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    // CDK
    PortalModule,
    OverlayModule,
    // Libs
    SnButtonModule,
    SnActionsModule,
    ResizableModule,
    MatTooltipModule,
    SnIconModule,
    MatButtonModule,
    TranslationModule,
  ],
  exports: [
    // Components
    SnDrawerComponent,
    SnDrawerHeaderComponent,
    SnDrawerFooterComponent,
    SnDrawerHeaderActionsComponent,
    // Directives
    SnDrawerTitleDirective,
    SnDrawerCloseDirective,
    SnDrawerContentDirective,
    SnDrawerNavButtonDirective,
    SnDrawerAppContentDirective,
  ],
  declarations: [
    // Containers
    SnDrawerContainer,
    // Components
    SnDrawerComponent,
    SnDrawerHeaderComponent,
    SnDrawerFooterComponent,
    SnDrawerHeaderActionsComponent,
    // Directives
    SnDrawerTitleDirective,
    SnDrawerCloseDirective,
    SnDrawerContentDirective,
    SnDrawerNavButtonDirective,
    SnDrawerAppContentDirective,
  ],
  providers: [
    SnDrawerService,
    { provide: OverlayContainer, useClass: ExistingFullscreenOverlayContainer },
  ],
})
export class SnDrawerModule {}
